import { imgix } from '@lib/imigx'
import { getProductAvailability } from './get-product-availability'
import { ProductDescriptionSchemaDetails } from '..'

export function getRolexRCPOProductSchemaDetails(data: ProductDescriptionSchemaDetails): any {
  let image = ''

  const { article, brandDescription } = data
  if (article && article.images && article.images.length > 0) {
    image = imgix(article.images[0] as string, { width: 750 })
  }

  const availability = getProductAvailability({ data: article })

  return {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: article.modelName,
    image,
    description: brandDescription,
    brand: {
      '@type': 'Brand',
      name: 'Rolex Certified Pre-Owned',
    },
    offers: {
      '@type': 'Offer',
      price: (article.price / 100).toFixed(2),
      priceCurrency: 'EUR',
      availability,
      itemCondition: 'https://schema.org/RefurbishedCondition',
    },
  }
}
